module.exports = __webpack_public_path__ + "img/clock.8aa544d4.svg";